import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialStatement from "@/components/EditorialStatement";
import FormulaOneSection from "@/components/FormulaOneSection";
import FootballSection from "@/components/FootballSection";
import ServicesGrid from "@/components/ServicesGrid";
import ProcessSection from "@/components/ProcessSection";
import GlobalSport from "@/components/GlobalSport";
import AboutSection from "@/components/AboutSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const Home = () => (
  <main>
    <Hero />
    <EditorialStatement />
    <FormulaOneSection />
    <FootballSection />
    <ServicesGrid />
    <ProcessSection />
    <GlobalSport />
    <AboutSection />
    <ContactSection />
  </main>
);

function App() {
  return (
    <div className="App bg-[#0A0A0A] text-[#F7F6F2]">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
